import { getAgencyConnect, ameexcety, ozonCities ,forcelogCities , onestaCities, cathedisCities, olivraisonCities } from "./auth";
import { citySenditTable } from "./city_sendit_table";
export const city = async () => {
  try {
    const agencyLivraison = await getAgencyConnect();
    const defaultagencyLivraison = agencyLivraison.find((a) => a.is_default);

    let cety = {};

    switch (defaultagencyLivraison?.agency) {
      case "62dcb8b0-0470-4dbf-bcca-13aa9a618f71":
        cety = await ameexcety();
        break;
      case "8136488d-fb1b-4696-9a16-a8cf968d9b38":
        cety = await ozonCities();
        break;
      case "e48eeff4-001c-4d04-aefa-4fc4db10bac4":
        cety = await forcelogCities();
        break;
      case "9ada9315-c969-4092-9e2f-84d7f171ebdf":
        cety = await onestaCities();
        break;
      case "cdd55a22-38ee-11f1-867f-0200c32b60b0": // olivraison
        cety = await olivraisonCities(); // { cities: [{ id: nom, name, price }] }
        break;
      case "2b7e8ca8-38f6-11f1-867f-0200c32b60b0":  // cathedis
        cety = await cathedisCities();
        console.log("cathedis cities", cety);
        break;
      case "b19e0f1f-368e-11f1-867f-0200c32b60b0":
          cety = {
            cities: citySenditTable
          };
        break;

      default:
        cety = { cities: {} };
        break;
    }

    const rawCities = cety?.cities || cety?.Cities || cety?.CITIES || {};

    const citiesArray = Object.entries(rawCities)
      .map(([key, c]) => ({
        id: c?.id || c?.ID || key,
        name: c?.name || c?.NAME || c?.city || "",
        code : c?.code || c?.CODE || "",
      }))
      .filter((city) => city.name);

    console.log("citiesArray", citiesArray);
    return citiesArray;
  } catch (err) {
    console.error("Load cities error", err);
    return [];
  }
};